const DRY_STYLING_CONTENT_LOAD = 'DRY_STYLING/CONTENT_LOAD';
const DRY_STYLING_SET_CONTENT = 'DRY_STYLING/SET_CONTENT';

export default {
    DRY_STYLING_CONTENT_LOAD,
    DRY_STYLING_SET_CONTENT,
};
